import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { IProps } from './SharingNewUnMount.types';

export const renderSharingNewUnMount = (data: IProps) => openPopupHelper({ popupName: popupNames.UNMOUNT_DIALOG, data });
